export default __webpack_public_path__ + "53ce8c7.png";